import * as React from 'react';

interface IAnimationProps {
  component: React.ComponentClass<any> | React.SFC<any>;
  children: JSX.Element | any;
  enabled: boolean;
  [key: string]: any;
}

export const Animation = (props: IAnimationProps) => {
  const { component, enabled, children, ...animationProps } = props;
  const AnimationComponent = component as any;
  return enabled ? (
    <AnimationComponent {...animationProps}>{children}</AnimationComponent>
  ) : (
    children
  );
};
